<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" placeholder="搜索商品名称"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="分类">
              <a-cascader
                          :options="cateOptions"
                          placeholder="选择分类"
                          changeOnSelect
                          v-model="queryParam.cate_ids"
                          :fieldNames = "{ label: 'title', value: 'key', children: 'children' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="状态">
              <a-select v-model="queryParam.status" placeholder="请选择"
                        allowClear >
                <a-select-option value="1">进行中</a-select-option>
                <a-select-option value="3">未开始</a-select-option>
                <a-select-option value="4">已结束</a-select-option>
                <a-select-option value="2">已下架</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="goodsAdd" >新建</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="setAllStatus(1)" key="1"><a-icon type="upload" />上架</a-menu-item>
          <a-menu-item @click="setAllStatus(2)" key="2"><a-icon type="download" />下架</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <s-table
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
      :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >
      <span slot="title1" slot-scope="text,record">
        <div style="margin-bottom: 10px;">{{record.title}} <a-tag color="pink" v-if="record.isFenxiao==true">分销商品</a-tag> <a-tag color="blue" v-if="record.isFenxiaoOrder==true">已有订单产出</a-tag></div>
        <div>
          <img style="width: 68px ; height: 68px; float: left" :src="record.pic_url" />
          <div style="color: #999;margin-left: 10px; float: left">
            <span style="color: #f5212d" v-if="record.price_range[0]!=record.price_range[1]">¥ {{record.price_range[0]|price}} - {{record.price_range[1]|price}}</span>
            <span style="color: #f5212d" v-else>¥ {{record.price_range[0]|price}}</span>
            <a-divider type="vertical" />
            库存: {{record.stock}}
            <br/>{{record.create_time|timeFormat}}
            <br/>
            <a-badge status="success" v-if="record.status==1" text="进行中" />
            <a-badge status="processing" v-else-if="record.status==3" text="未开始" />
            <a-badge status="default" v-else-if="record.status==4" text="已结束" />
            <a-badge status="default" v-else text="已下架" />
          </div>
        </div>
      </span>
      <span slot="views" slot-scope="text,record">
        <template >
        <div>{{record.views_count}}
        </div>
          </template>
      </span>
      <span slot="sold" slot-scope="text,record">
        <template >
        <div>{{record.sold_count}}
        </div>
        </template>
      </span>
      <span slot="rank" slot-scope="text,record">
        <template >
        <editable-cell :text="text" @change="onRankChange(record.id, 'rank', $event)"/>
        </template>
      </span>
      <span slot="action" slot-scope="text,record">
        <template >
<!--          <span v-if="record.status==1">-->
<!--          <a v-if="record.goods_recom==2" @click="onHandleRecom(record)">推荐商品到首页</a> -->
<!--              <a v-if="record.goods_recom==1" @click="NotHandleRecom(record)">取消推荐商品到首页</a> -->
<!--              <a-divider type="vertical" />-->
<!--          </span>-->
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-popconfirm title="删除后不可恢复,确定删除吗?" @confirm="deleteGoods(record)"  okText="确定" cancelText="取消">
            <a href="javascript:;" >删除</a>
          </a-popconfirm>
          <a-divider type="vertical"/>
              
        </template>
        <a-dropdown>
          <a class="ant-dropdown-link">
            更多 <a-icon type="down" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item>
            <a href="javascript:;" @click="onShare(record)">小程序推广</a>
            </a-menu-item>
             <a-menu-item>
                <a href="javascript:;" @click="onH5Share(record)">H5版推广</a>
              </a-menu-item>
<!--            <a-menu-item>-->
<!--              <a @click="handleSellerReward(record)">分销配置</a>-->
<!--            </a-menu-item>-->
            
          </a-menu>
        </a-dropdown>
      </span>
    </s-table>
    <GoodsSellerRewardForm :visible="sellerRewardVisible" :goodsId="sellerRewardGoodsId" @sellerRewardDone="sellerRewardDone"></GoodsSellerRewardForm>
    <GoodsDealtownRewardForm :visible="dealtownRewardVisible" :goodsId="dealtownRewardGoodsId" @dealtownRewardDone="dealtownRewardDone"></GoodsDealtownRewardForm>

    <a-modal title="小程序推广" v-model="shareVisible" @ok="shareVisible=false">
      <p style="text-align: center">
        <img :src="share.wxmini_pic_url" />
      </p>
    </a-modal>
    <a-modal title="H5推广" v-model="h5ShareVisible" @ok="h5ShareVisible=false">
      <p style="text-align: center">
        <img :src="share.wxmini_pic_url" />
      </p>
      <p>商品详情地址</p>
      <p>{{share.site_url}} &nbsp;&nbsp; <a  
        v-clipboard:copy="share.site_url"
        v-clipboard:success="onCopy"
        v-clipboard:error="onError">点此复制</a></p>
    </a-modal>

  </a-card>
</template>

<script>
  import STable from '@/components/table/'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import AInput from 'ant-design-vue/es/input/Input'
  import EditableCell from '@/components/EditableCell/'
  import GoodsSellerRewardForm from '../goods/GoodsSellerRewardForm.vue'
  import GoodsDealtownRewardForm from '../goods/GoodsDealtownRewardForm.vue'
  import moment from 'moment'
  import PriceInput from '@/components/PriceInput/'

  import { getGoodsList,getCateTreeList,setGoodsStatus,setGoodsAllStatus,deleteGoods,setGoodsRank,onHandleRecom ,NotHandleRecom  } from '@/api/hotelGoods'
  export default {
    name: 'HotelGoodsList',
    components: {
      AInput,
      ATextarea,
      STable,
      EditableCell,
      GoodsSellerRewardForm,
      GoodsDealtownRewardForm,
      PriceInput
    },
    data () {
      return {
        visible: false,
        sellerRewardVisible: false,
        dealtownRewardVisible: false,
        sellerRewardGoodsId:0,
        dealtownRewardGoodsId:0,
        saveLoading:false,
        shareVisible: false,
        h5ShareVisible:false,
        share:{
          site_url:'',
          wxmini_pic_url:'',
        },
        formData:{
          title:'',
          rules:[],
        },
        labelCol: {
//          xs: { span: 24 },
//          sm: { span: 5 },
          xs: { span: 24 },
          sm: { span: 2 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12 },
        },
        form: this.$form.createForm(this),
        mdl: {},

        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {
          keywords:'',
        },
        cateOptions:[],
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '80px'
          },
          {
            title: '名称',
            dataIndex: 'title',
            scopedSlots: { customRender: 'title1' },
          },
          {
            width:'100px',
            title: '点击数',
            dataIndex: 'views_count',
            scopedSlots: { customRender: 'views' },
          },
          {
            title: '销量',
            width:'100px',
            dataIndex: 'sold_count',
            scopedSlots: { customRender: 'sold' },
          },
          {
            title: '排序',
            width:'150px',
            dataIndex: 'rank',
            scopedSlots: { customRender: 'rank' },
          },
          {
            title: '操作',
            dataIndex: 'action',
            width: '320px',
            scopedSlots: { customRender: 'action' },
          }
        ],
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          console.log('loadData');
          console.log(this.parameter);
          this.queryParam.cate_id = 0;
          if(this.queryParam.cate_ids && this.queryParam.cate_ids.length) {
            this.queryParam.cate_id = [...this.queryParam.cate_ids].pop();
          }
          this.queryParam = Object.assign( this.queryParam,parameter);
          return getGoodsList(this.queryParam)
            .then(res => {
              console.log('res');
              return res.data
            })
        },

        selectedRowKeys: [],
        selectedRows: [],
      }
    },
    computed:{
    },
    created(){
    },
    mounted(){
      let that = this;
      getCateTreeList()
              .then(res => {
                that.cateOptions =  res.data
              });
    },
    methods: {
      goodsAdd(){
        const {href} = this.$router.resolve({name:'HotelGoodsForm'});
        window.open(href, '_blank');
      },
      handleEdit(record){
        const {href} = this.$router.resolve({name:'HotelGoodsForm',query:{id:record.id}});
        window.open(href, '_blank');
      },
      handleSellerReward(record){
        let that = this;
        that.sellerRewardGoodsId = record.id;
        that.sellerRewardVisible = true;
      },
      handleDealtownReward(record){
        let that = this;
        that.dealtownRewardGoodsId = record.id;
        that.dealtownRewardVisible = true;
      },
      //推荐到首页
      onHandleRecom(recode){
        console.log(recode)
        onHandleRecom({goods_id:recode.id}).then(res=>{
            this.$message.success('设置成功')
            this.$refs.table.refresh(true)
        })
      },
      //取消推荐到首页
      NotHandleRecom(recode){
          NotHandleRecom({goods_id:recode.id}).then(res=>{
            this.$message.success('设置成功')
            this.$refs.table.refresh(true)
        })
      },

    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(true)
    },
      setAllStatus(status){
        let self = this;
        setGoodsAllStatus({
          ids:self.selectedRowKeys,
          status:status,
        })
                .then(res => {
                  self.$message.success('设置成功')
                  self.$refs.table.refresh(true)
                })
      },
      setStatus(goods_id,status){
        setGoodsStatus({
          id:goods_id,
          status:status,
        })
                .then(res => {
                  self.$message.success('设置成功')
                  self.$refs.table.refresh(true)
                })

      },
     // 删
      deleteGoods(record) {
        let self = this
        deleteGoods({ id: record.id }).then(res => {
          self.$message.success('删除成功')
          self.$refs.table.refresh(true)
      }).catch(err =>{
          self.$message.error(err.data.msg)
        })
    },
    onRankChange(key, dataIndex, value) {
      let self = this;
      setGoodsRank({
        id: key,
        rank:value
      }).then(res => {
        self.$refs.table.refresh(true)
      }).catch(err =>{
        self.$message.error(err.data.msg)
      })
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      console.log('换页',selectedRowKeys,selectedRows)
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },
      sellerRewardDone(){
        this.sellerRewardVisible = false;
      },
      dealtownRewardDone(){
        this.dealtownRewardVisible = false;
      },
      onShare(record){
        let that = this;
        that.shareVisible = true;
        that.share.wxmini_pic_url = record.wxmini_pic_url;
      },
       onH5Share(record) {
      console.log(record)
      let that = this
      that.h5ShareVisible = true
      that.share.site_url=record.h5_url
      that.share.wxmini_pic_url = record.h5_pic_url
    },
    onCopy(e){
      this.$message.success('复制成功')
      },
      onError(e){
        this.$message.error('复制失败')
      }
    },
    watch: {
      /*
      'selectedRows': function (selectedRows) {
        this.needTotalList = this.needTotalList.map(item => {
          return {
            ...item,
            total: selectedRows.reduce( (sum, val) => {
              return sum + val[item.dataIndex]
            }, 0)
          }
        })
      }
      */
    }
  }
</script>